import React from "react";
import { CommonCard } from "./common-card";
import { CommuteCard } from "./commute-card";
import { PriceLayoutCard } from "./price-layout-card";
export const CustomSubtopicCard = (props) => {
    var _a;
    const variant = (_a = props.variant) !== null && _a !== void 0 ? _a : "common";
    if (variant === "commute") {
        return React.createElement(CommuteCard, Object.assign({}, props));
    }
    if (variant === "price-layout") {
        return React.createElement(PriceLayoutCard, Object.assign({}, props));
    }
    return React.createElement(CommonCard, Object.assign({}, props));
};
